import Http from '@/utils/http';

/**
   * 获取商户余额
   */
export const postSwitchLanguage = (lang) => {
  return Http.post('/merLogin/switchLanguage', { language: lang });
};
